import React, { useEffect } from "react";
import useDrawTraceMap, {
  DrawTraceMapProps,
} from "../../../../hooks/useDrawTraceMap";
import styles from "./index.module.scss";
import useQuery from "../../../../hooks/useQuery";

export const MAP_PAGE_LOCAL_STORAGE_KEY = "map_page_draw_trace_data";

const MapView = () => {
  const query = useQuery();
  const title = query.get("title");
  const { containerId, drawTraceMap } = useDrawTraceMap();
  document.title = title || "地图";

  useEffect(() => {
    const data: DrawTraceMapProps = JSON.parse(
      localStorage.getItem(MAP_PAGE_LOCAL_STORAGE_KEY) || "null"
    );
    if (data) drawTraceMap(data);
  }, [drawTraceMap]);

  return <div className={styles.mapView} id={containerId} />;
};

export default MapView;
